module.exports = __webpack_public_path__ + "img/altica_premium_Full.24defd06.png";